<template>
    <div class="whiteviewer">
        <div class="aside" >
            <div :class="menuIdx == index?'btn selected':'btn'"  v-for="(item,index) in aside" :key="item.id" @click="select(item,index)">
                <img :src="item.src" alt="" /><span>{{item.name}}</span>
            </div>
        </div>

        <div class="floor" v-show="showFloorIndicator">
            <div class="warp">
                <div :class="currentFloor == index?'flooritem se':'flooritem'" v-for="(item,index) in floorList" :key="index" @click="selectFloor(index)">
                    {{item}}
                </div>
            </div>
            <div class="top" @click="top"></div>
            <div class="bottom" @click="bottom"></div>
        </div>
        
        <Viewer ref="viewerwhite" @clickBuild="clickBuild" @selectFloor="selectFloor" :screenWhite="true"/>
    </div>
</template>

<script>
const Viewer = ()=>import('./viewer/Viewer.vue')
import { buildData, roomsArr } from '../utils/viewer/lutai_wisdom_building.js'
export default {
    name:'whiteviewer',
    data(){
        return {
            menuIdx:0,
            aside: [],
            buildsArr:buildData(),
            showFloorIndicator:false,
            asideArr: [
                [{
                    id: 1,
                    name: "概况",
                    src: require("../assets/img/主视角.png"),
                },
                // {
                //     id: 2,
                //     name: "站点",
                //     src: require("../assets/img/站点概览.png"),
                // },
                {
                    id: 3,
                    name: "建筑",
                    src: require("../assets/img/louyu_norwhite.png"),
                }],
                [{
                    id: 1,
                    name: "概况",
                    src: require("../assets/img/主视角.png"),
                },
                {
                    id: 2,
                    name: "CAD",
                    src: require("../assets/img/cascades.png"),
                },
                {
                    id: 3,
                    name: "热力图",
                    src: require("../assets/img/relitu_nor.png"),
                }],
            ],
            selectBuild:'', //三维场景内选中的楼宇
            floorList:[],  // 右侧楼层选择器
            currentFloor:-1,  // 当前选中的楼层
        }
    },
    components:{
        Viewer
    },
    watch: {
        currentFloor(val){
            if(val == -1){
                this.aside = this.asideArr[0]
            }else{
                this.aside = this.asideArr[1]
            }
        },
        selectBuild(val){
            console.log(val);
            this.$refs.viewerwhite.closeBuildBox()
            if(val !== ''){
                this.$refs.viewerwhite.showBuildBoxFloor(val)
            }
            
        },
        showFloorIndicator(val){
            if(this.selectBuild == '') return 
            if(val){
                this.$refs.viewerwhite.showBuildBoxFloor(this.selectBuild)
            }else{
                this.$refs.viewerwhite.closeBuildBox(this.selectBuild)
            }
        }
        
    },
    created(){
        this.aside = this.asideArr[0]
    },
    mounted(){
        setTimeout(()=>{
            this.select(this.aside[0],0)
        },2000)
    },
    methods:{
        select(val, idx){
            this.menuIdx = idx 
            console.log(val);
            switch(val.name){
                case '概况' :
                    this.currentFloor = -1
                    this.showFloorIndicator = false
                    this.$refs.viewerwhite.closeBuildBox()
                    this.$refs.viewerwhite.cancleMenuBuild()
                    this.$refs.viewerwhite.selectMenuPark()
                    break;
                case '建筑' :
                    this.$refs.viewerwhite.cancleMenuPark()
                    this.$refs.viewerwhite.addBuildPopup()
                    break;
                default:
                    break;
            }
        },
        selectFloor(index){
            this.currentFloor = index
            this.$refs.viewerwhite.selectFloor(this.floorList[index])
        },
        top(){
            document.getElementsByClassName('warp')[0].scrollTop -= 400
            
        },
        bottom(){
            document.getElementsByClassName('warp')[0].scrollTop += 400
        },
        clickBuild(build){
            this.currentFloor = -1
            this.showFloorIndicator = build.flag
            this.selectBuild = build.id
            if(build.id != ''){
                this.floorList = this.buildsArr.find(item =>item.id == build.id).floors
            }else{
                this.showFloorIndicator = false
            }
            
        }
    }
}
</script>

<style lang="less" scoped>
.whiteviewer{
    width: 100vw;
    height: 100vh;
    position: relative;
    .aside {
        width: 7vw;
        height: 45vh;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 3vw;
        margin: auto;
        z-index: 1;
        background: #ffffff;
        border-radius: 2vh;
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 0.5vh 0;
        justify-content: space-evenly;
        flex-direction: column;
        
        .btn{
            width: 100%;
            height: 10vh;
            padding-top: 10rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            border:2px solid transparent ;
            &>img{
                display: block; 
                width:2.2vw ;
                height: 3.5vh;
            }
            &>span{
                display: block;
                color: #333;
                font-size: 2.5vh;
            }
        }
        
        .selected{
            border-right:2px solid #0d94ff ;
            color: #0d94ff;
            background-color: rgba(13,148,255, 0.1);
        }
    }

    .floor{
        width: 7vw;
        height: 45vh;
        position: absolute;
        top: 0;
        right: 3vw;
        bottom: 0;
        margin: auto;
        z-index: 1;
        background: #fff;
        border: 1px solid #0d94ff;
        border-radius: 2vh;
        cursor: pointer;
        padding: 1.5vh 0;
        .top{
            width: 0;
            height: 0;
            position: absolute;
            top: -0.5vh;
            left: 0;
            right: 0;
            margin: auto;
            border:1.2vh solid transparent ;
            border-bottom: 1.2vh solid #000;
        }
        .bottom{
            width: 0;
            height: 0;
            position: absolute;
            bottom:  -0.5vh;
            left: 0;
            right: 0;
            margin: auto;
            border:1.2vh solid transparent ;
            border-top: 1.2vh solid #000;
        }
        .warp{
            width: 100%;
            max-height: 37.5vh;
            overflow:scroll;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            .flooritem{
                height: 6.5vh;
                line-height: 6.5vh;
                width: 100%;
                font-size: 1.8vh;
                text-align: center;
                // background: #0d94ff;
                margin-bottom: 0.5vh ;
            }
            .flooritem:last-child{
                margin-bottom: 0 ;
            }
            .se{
                border-right:2px solid #0d94ff ;
                color: #0d94ff;
                background-color: rgba(13,148,255, 0.1);
            }
        }
        .warp::-webkit-scrollbar{
            display: none;
        }
    }
}
</style>